module.exports = [{"ruleKey":"A","colour":"#4488ee","operation":"root","successors":{"kind":"all","rule":"B"},"scale":0.62},{"ruleKey":"B","colour":"#4488ee","successors":{"kind":"all","rule":"C"},"operation":"truncatedPyramid","scale":1},{"ruleKey":"C","colour":"#4488ee","successors":{"kind":"all","rule":"D"},"operation":"jump","scale":0.64},{"ruleKey":"D","colour":"#4488ee","successors":{"kind":"specific","rules":["B",null,null,null,null,null]},"operation":"pyramid","scale":0.53}]


//////////////////
// WEBPACK FOOTER
// ./src/data/examples/complex.json
// module id = 103
// module chunks = 35783957827783 213497200229540